import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Phone, Mail, Calendar } from "lucide-react";

export default function CrearActividadDialog({ open, onClose, onSubmit, isLoading }) {
  // Calcular fecha por defecto: 3 días desde hoy a las 9:00
  const calcularFechaDefecto = () => {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() + 3);
    fecha.setHours(9, 0, 0, 0);
    return fecha;
  };

  const [tipo, setTipo] = useState("llamada");
  const [fechaProgramada, setFechaProgramada] = useState(calcularFechaDefecto());
  const [descripcion, setDescripcion] = useState("");

  const formatDateTimeLocal = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handleSubmit = () => {
    onSubmit({
      tipo,
      fecha_programada: fechaProgramada.toISOString(),
      descripcion,
      // Firestore where('completada','==',false) ignora docs sin el campo,
      // así que los recordatorios no aparecían en la agenda.
      completada: false
    });
  };

  const handleSkip = () => {
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-indigo-600" />
            ¿Programar recordatorio?
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div>
            <Label className="text-sm text-gray-600 mb-2 block">Tipo de actividad</Label>
            <div className="flex gap-2">
              <Button
                type="button"
                variant={tipo === "llamada" ? "default" : "outline"}
                onClick={() => setTipo("llamada")}
                className={tipo === "llamada" ? "bg-indigo-600 hover:bg-indigo-700 flex-1" : "flex-1"}
              >
                <Phone className="w-4 h-4 mr-2" />
                Llamada
              </Button>
              <Button
                type="button"
                variant={tipo === "email" ? "default" : "outline"}
                onClick={() => setTipo("email")}
                className={tipo === "email" ? "bg-indigo-600 hover:bg-indigo-700 flex-1" : "flex-1"}
              >
                <Mail className="w-4 h-4 mr-2" />
                Email
              </Button>
            </div>
          </div>

          <div>
            <Label className="text-sm text-gray-600 mb-2 block">Fecha y hora</Label>
            <Input
              type="datetime-local"
              value={formatDateTimeLocal(fechaProgramada)}
              onChange={(e) => setFechaProgramada(new Date(e.target.value))}
              className="w-full"
            />
          </div>

          <div>
            <Label className="text-sm text-gray-600 mb-2 block">Nota (opcional)</Label>
            <Input
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Ej: Preguntar si recibió el presupuesto"
            />
          </div>
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={handleSkip}>
            No, gracias
          </Button>
          <Button 
            onClick={handleSubmit} 
            disabled={isLoading}
            className="bg-indigo-600 hover:bg-indigo-700"
          >
            {isLoading ? "Creando..." : "Crear recordatorio"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}